import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'admin';
  loading: boolean = false;
  isLoginPage: boolean = false;
  constructor(private location: Location) {
    // setTimeout(() => {
    //   this.isLoginPage = this.location.path().includes('/login') ? true : false;
    // }, 1000);
  }
}
